import { Fragment, type ReactNode } from 'react';

import { SectionSeparator } from './SectionSeparator';
import { SectionUnavailable } from './SectionUnavailable';

export interface SectionBlock {
  key: string;
  hasData: boolean;
  node: ReactNode;
}

interface SectionBlocksProps {
  /** The section's title, named by the empty state when no block has data. */
  category: string;
  blocks: SectionBlock[];
}

/**
 * The body of a report section: only the blocks with data, a separator between each pair, and
 * the section's empty state when none has any. Filtering here, before separators are placed,
 * is what keeps a separator from leading, trailing or doubling up around an absent block.
 */
export const SectionBlocks = ({ category, blocks }: SectionBlocksProps) => {
  const present = blocks.filter((block) => block.hasData);

  if (present.length === 0) {
    return <SectionUnavailable category={category} />;
  }

  return (
    <div className="flex flex-col gap-10">
      {present.map((block, index) => (
        <Fragment key={block.key}>
          {index > 0 && <SectionSeparator />}
          {block.node}
        </Fragment>
      ))}
    </div>
  );
};
